import { JWTPayload } from "utils/models/JwtPayload";
import { JwtValidationErrors } from "utils/JwtValidationErrors";

export default function validateJWT(token: string): JWTPayload | null {
  try {
    const parts = token.split(".");

    if (parts.length !== 3) {
      console.error("Invalid JWT format");
      return {
        aud: "",
        iss: "",
        exp: 0,
        iat: 0,
        nbf: 0,
        jti: "",
        sub: "",
        email: "",
        isInvite: false,
        existingUser: null,
        error: JwtValidationErrors.InvalidToken,
        isValidToken: false,
      };
    }

    const payload = parts[1];
    const paddedPayload = payload.padEnd(
      payload.length + ((4 - (payload.length % 4)) % 4),
      "="
    );

    const decodedPayload = atob(
      paddedPayload.replace(/-/g, "+").replace(/_/g, "/")
    );

    const parsedToken = JSON.parse(decodedPayload);

    if (parsedToken.exp < Date.now() / 1000) {
      console.error("JWT has expired");
      parsedToken.error = JwtValidationErrors.TokenExpired;
    }

    parsedToken.isValidToken = parsedToken.error === undefined;
    return parsedToken;
  } catch (error) {
    console.error("Error decoding JWT:", error);
    return null;
  }
}
